import { mapFieldsUser } from '@/store/mapFields';

export default {
  computed: {
    ...mapFieldsUser(['user']),

    initials() {
      return this.getInitials(this.user);
    },
  },

  methods: {
    getInitials(user) {
      const userObject = user;
      if (!userObject.firstname) return '';
      const chars = `${userObject.firstname.charAt(0)}${userObject.lastname.charAt(0)}`;
      return chars.toUpperCase();
    },
  },
};
